import { resolveDirective as _resolveDirective, createVNode as _createVNode } from "vue";
import { Transition } from "vue";
import { RouterView } from "vue-router";
import { ElConfigProvider } from 'element-plus';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
import Render from "@/render/Render";
export class App extends Render {
  render() {
    return _createVNode("div", {
      "class": "w-screen h-screen overflow-hidden"
    }, [_createVNode(ElConfigProvider, {
      "locale": zhCn
    }, {
      default: () => [_createVNode(RouterView, null, {
        default: scope => _createVNode(Transition, {
          "name": "fade",
          "mode": "out-in"
        }, {
          default: () => [_createVNode("div", {
            "class": "h-full"
          }, [scope.Component])]
        })
      })]
    })]);
  }
}
export default defineComponent({
  name: 'App',
  props: App.defineProps,
  emits: App.defineEmits,
  created() {
    this.render.onCreated?.();
  },
  beforeMount() {
    this.render.OnBeforeMount?.();
  },
  mounted() {
    this.render.onMounted?.();
  },
  unmounted() {
    this.render.onUnmounted?.();
  },
  beforeUpdate() {
    this.render.onBeforeUpdate?.();
  },
  updated() {
    this.render.OnUpdated?.();
  },
  activated() {
    this.render.onActivated?.();
  },
  deactivated() {
    this.render.onDeactivated?.();
  },
  beforeUnmount() {
    this.render.onBeforeUnmount?.();
  },
  setup(props, context) {
    const render = new App();
    render.props = props;
    render.context = context;
    render.emit = context.emit.bind(render.context);
    render?.onSetup?.();
    return {
      ...render,
      render: render
    };
  },
  render(setup) {
    // 挂载插槽
    this.render.slots = useSlots.call(setup);
    // 挂载属性
    this.render.attrs = useAttrs.call(setup);
    // 挂载路由参数
    this.render.route = useRoute.call(setup);
    return this.render.render();
  }
});